import BranchLocationMapView from './BranchLocationMapView';

export default BranchLocationMapView;
